var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { attrs: { type: "card" } },
    [
      _c("template", { slot: "header" }, [_vm._v("区域划分")]),
      _c(
        "div",
        { staticStyle: { height: "400px", margin: "-16px" } },
        [
          _c(
            "SplitPane",
            {
              attrs: {
                "min-percent": 20,
                "default-percent": 30,
                split: "vertical"
              }
            },
            [
              _c("template", { slot: "paneL" }, [
                _c("div", { staticStyle: { margin: "10px" } }, [_vm._v("左")])
              ]),
              _c(
                "template",
                { slot: "paneR" },
                [
                  _c(
                    "SplitPane",
                    { attrs: { split: "horizontal" } },
                    [
                      _c("template", { slot: "paneL" }, [
                        _c("div", { staticStyle: { margin: "10px" } }, [
                          _vm._v("右上")
                        ])
                      ]),
                      _c("template", { slot: "paneR" }, [
                        _c("div", { staticStyle: { margin: "10px" } }, [
                          _vm._v("右下")
                        ])
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ],
            2
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }